import { useEffect } from "react";
import useSWR from "swr";
import { swrKey } from "@/lib/swr";
import { useNavigate, useParams } from "react-router-dom";
import { ListLoading } from "@/components/list/status-text";
import Page404 from "@/components/zthd/404";
import { pickWorkItem, prdDetailPath } from "@/lib/paths";
import { useVisibleAppIds } from "@/hooks/apps";
import type { Prd } from "@/types/domain";

// Legacy /bugs/:id links (Feishu history, bookmarks): bugs merged into prds
// (issue unification) — resolve the old numeric id via legacyBugId and land
// on the issue detail. Kept as a route so old links never break.
const BugLegacyRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useSWR<{ data: Prd[] }>(
    id ? swrKey("/prds", { legacyBugId: id }) : null
  );
  const issue = data?.data?.[0];
  // Fallback work item only from an App the user can see (wait for /apps).
  const visibleAppIds = useVisibleAppIds();

  useEffect(() => {
    if (issue && visibleAppIds)
      navigate(
        prdDetailPath(issue.id, issue.engagementId ?? pickWorkItem(issue.engagements, visibleAppIds)?.id),
        { replace: true }
      );
  }, [issue, visibleAppIds, navigate]);

  if (isLoading || issue) return <ListLoading />;
  return <Page404 />;
};

export default BugLegacyRedirect;
